export const dataInitialSgaProduct = () => {
    return {
        pictograms: [],
        phrases: {
            phrasesH: '',
            phrasesP: ''
        },
        measures: "[[1, 1], [1, 1], [1, 1], [1, 1]]"
    }
}

export default {
    filterProductSga2: {
        version_id: null,
        language_id: null,
        company_id: null,
        subCategories: [],
        subNotDangers: [],
        pictograms: []
    },
    sgaProduct: dataInitialSgaProduct()
};
